export function getSupplierRetailersFromStateSelector(state) {
  return state?.role?.supplier?.supplier_retailers ?? [];
}
